export default class Collect {
	constructor(options = [], selected = []) {
		this._options = options;
		this._selected = selected
		this._optionsKey = 'id'
		this._selectedKey = 'system_option_id'
	}

	toggle(option, type = null) {
		let a = this._selected.findIndex(b => {
			return b[this._selectedKey] == option[this._optionsKey]
				&& b.type == type
		});

		if (a >= 0) {
			this._selected.splice(a, 1)
		} else {
			this._selected.push({
				[this._selectedKey]: option[this._optionsKey],
				type: type
			})
		}
	}

	filter(callback) {
		return this._options.filter(a => callback(a))
	}

	selected(option) {
		return this._selected.findIndex(a => {
			return a[this._selectedKey] == option[this._optionsKey]
		}) >= 0
	}

	value(selectable = []) {
		let v = [];

		for (let a = 0; a < selectable.length; a++) {
			if (this.selected(selectable[a])) {
				v.push(selectable[a][this._optionsKey])
			}
		}

		return v
	}
}